import React from 'react';
import BannerBase, {
  IBannerProps as IBaseBannerProps
} from 'components/core/Banner/Banner';
import { ThemeFamilies } from 'models';
import { BannerVariants } from '@rapyd/react-ui-library/dist/components/Banner';
import { IconName } from '@rapyd/react-ui-library/dist/components/Icon';

interface IBannerProps extends IBaseBannerProps {}

const Banner = ({
  className,
  name = '',
  variant = BannerVariants.FILLED,
  themeFamily = ThemeFamilies.INFO,
  title = '',
  subTitle = '',
  buttonProps,
  customIconName = IconName.INFO_SQ,
  ...rest
}: IBannerProps) => {
  return (
    <BannerBase
      className={className}
      name={name}
      variant={variant}
      themeFamily={themeFamily}
      title={title}
      subTitle={subTitle}
      buttonProps={buttonProps}
      customIconName={customIconName}
      {...rest}
    />
  );
};

export default Banner;
